module.exports = __webpack_public_path__ + "img/men.b2036417.svg";